"use strict";
/*
 * Created on 01 02 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");

var NumberInRangeValidator_1 = require("./NumberInRangeValidator");
/**
 * @author Jaroslav Sevcik
 */


var DayOfWeekValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(DayOfWeekValidator, _Validator_1$Validato);

  function DayOfWeekValidator() {
    var _this;

    _classCallCheck(this, DayOfWeekValidator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayOfWeekValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
    _this.numberRangeValidator = new NumberInRangeValidator_1.NumberInRangeValidator(1, 7);
    return _this;
  }

  _createClass(DayOfWeekValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (value.contains(0)) {
        if (value.size !== 1) {
          return new ValidationResult_1.ValidationError(DayOfWeekValidator.NONE_VALUE_SHOULD_BE_ALONE, value);
        }

        return new ValidationResult_1.ValidationSuccess(value);
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = value[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var number = _step.value;
          var result = this.numberRangeValidator.validate(number, ValidationLevel_1.ValidationLevel.Fast);

          if (result instanceof ValidationResult_1.ValidationError) {
            return result;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return DayOfWeekValidator;
}(Validator_1.Validator);

exports.DayOfWeekValidator = DayOfWeekValidator;
DayOfWeekValidator.NONE_VALUE_SHOULD_BE_ALONE = 'NONE_VALUE_SHOULD_BE_ALONE';